import { DocumentInfo, DocumentTypePrimitive } from "@infoland/iprova-api";
import Shared from "./shared";
import storeHelper from "./store/store-helper";

export default async (to, from, next) => {
    let documentId: string = to.params.documentId;
    let documentData: DocumentInfo = await (await storeHelper.documentStore.loadDocumentAsync(documentId)).documentInfo;
    if (documentData !== null) {
        if (
            documentData.type == DocumentTypePrimitive.objective_matrix ||
            documentData.type == DocumentTypePrimitive.process ||
            (documentData.type == DocumentTypePrimitive.web_share &&
                (documentData.web_share_source_document_type_primitive == DocumentTypePrimitive.objective_matrix ||
                    documentData.web_share_source_document_type_primitive == DocumentTypePrimitive.process))
        ) {
            let path = `${Shared.iProvaUrl}/iDocument/?DocumentID=${documentId}&FromVue=true`;
            window.open(path, "_self");
            return true;
        } else {
            next();
            return false;
        }
    }
};
